export const searchTypes = {
  TESTS: 'Tests',
  ITEMS: 'Items',
  ASSIGNMENTS: 'Assignments',
}
